import styled from "styled-components";
export const Button = styled.button`
  cursor: pointer;
  text-decoration: none;
`;
export const RadeTitle = styled.h1`
  font-family: Metrophobic;
`;
